const SCOPE = 'prepare-disclosures.readiness';

export const ReadinessStepTestIds = {
  ROOT: SCOPE,
  CHECKLIST: `${SCOPE}.checklist`,
  SUBTITLE: `${SCOPE}.subtitle`,
  SNAPSHOT: `${SCOPE}.snapshot`,
  CONTINUE_CALLOUT: `${SCOPE}.continue-callout`,
  BRANDING_NUDGE: `${SCOPE}.branding-nudge`,
  BRANDING_ADD_LOGO: `${SCOPE}.branding-nudge.add-logo`,
  BRANDING_SKIP: `${SCOPE}.branding-nudge.skip`,
  SEND_ALERT: `${SCOPE}.send-alert`,
  getCheckRowId: id => `${SCOPE}.check-${id}`,
  getCheckFixId: id => `${SCOPE}.check-${id}.fix`,
};
